import { HEALTHCARE_TEST_TYPES, TEST_TYPES } from 'Constants';
import React from 'react';

const TestIcon = ({ width, color, type, isPadded }) => {
  width = width ? width : '50px';
  color = color ? color : '#118996';
  type = type ? type : 'survey';
  isPadded = typeof isPadded === 'undefined' ? false : !!isPadded;

  switch (type) {
    case 'survey':
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          style={{
            padding: isPadded ? '15%' : 0,
          }}
        >
          <path
            fill={color}
            d="M56.65 20.15h6.9v-7.7h-7.7c.5 1.1.8 2.3.8 3.6zm-16.9-4.1c0-1.3.3-2.5.8-3.6h-7.3v7.7h6.5zm-15.6-5.5h7.7v11.6h-7.7zm-4.4 73.6c-.3.6.1 1.4.7 1.6.1.1.3.1.4.1.5 0 1-.3 1.2-.8l17.7-49.3h-2.7zm55.5 0-17.3-48.4h-2.7l17.7 49.2c.2.5.7.8 1.2.8.1 0 .3 0 .4-.1.6-.1 1-.9.7-1.5zm-27.3-45.7c-.7 0-1.3.6-1.3 1.3v37.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3v-37.3c0-.7-.6-1.2-1.3-1.2zm7.2-22.4c0-3.8-3.1-6.9-6.9-6.9-3.8 0-6.9 3.1-6.9 6.9v10.8h13.8zm-20.8 12.3h27.8v5.8h-27.8z"
          />
        </svg>
      );
    case TEST_TYPES.DILUTION:
    case TEST_TYPES.SMALL_DILUTION:
    case TEST_TYPES.LARGE_DILUTION:
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          style={{
            padding: isPadded ? '15%' : 0,
          }}
        >
          <path
            fill={color}
            d="M75.55 75.9h-56.1c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4h56.1c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4zm-8.8-8.7h8.4c.3 0 .5-.4.5-.7V42.3c0-1.4-1.2-2.6-2.5-2.6h-4.4c-1.4 0-2.9 1.2-2.9 2.6v24.2c.1.3.7.7.9.7zm-15.6 0h8.4c.3 0 .6-.4.6-.7v-32c0-1.4-1.3-2.4-2.6-2.4h-4.4c-1.4 0-3.1 1.1-3.1 2.4v32c.1.3.9.7 1.1.7zm-15.9 0h8.4c.1 0 0-.1 0-.1.2 0 .2-.3.2-.6V26.8c0-1.4-.9-2.6-2.2-2.6h-4.5c-.8 0-1.4.4-1.8 1-.3.4-.5 1-.5 1.6v39.7c.1.3.1.7.4.7zm-14.8 0h8.4c.3 0 0-.4 0-.7V19c0-1.4-.7-2.7-2.1-2.7h-4.4c-1.4 0-2.5 1.3-2.5 2.7v47.5c.1.3.4.7.6.7z"
          />
        </svg>
      );
    case TEST_TYPES.RECIRCULATION:
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
          style={{
            padding: isPadded ? '15%' : 0,
          }}
        >
          <path
            fill={color}
            d="M34.517 24.9c1.5-.6 3.2-1.1 4.8-1.4 7.5-1.4 15.3.9 20.9 6.2l.7.6 4.4-4.8-.7-.6c-7.1-6.7-17-9.7-26.6-7.9-3 .6-5.9 1.6-8.6 3l-5.8-5.7-5.5 21.4 21.3-6zm31.8 5.9-5.6 21.4 6.7-1.8c-1.3 9.3-8 17.1-17 19.8l-.9.3 1.8 6.3.9-.3c12.6-3.7 21.4-14.8 22-27.9l7.8-2.1zm-37.4 35.3c-4.7-3.6-7.8-8.8-8.9-14.7-.6-3.3-.5-6.6.2-9.8l.2-.9-6.4-1.5-.2.9c-1 4.1-1.1 8.3-.3 12.5 1.6 8.5 6.4 15.7 13.6 20.2l-2 7.9 21.3-5.9-15.7-15.5z"
          />
        </svg>
      );
    case 'mini_survey':
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          style={{
            padding: isPadded ? '15%' : 0,
          }}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill={color}
            d="M49.781 12.5c-16.8 0-30.5 13.7-30.5 30.5 0 7.6 2.8 14.8 7.8 20.4l-11.1 11.4c-1.7 1.8-1.7 4.6.1 6.4.9.9 2 1.3 3.1 1.3 1.2 0 2.3-.5 3.2-1.4l11.7-12c4.7 2.8 10.2 4.4 15.7 4.4 16.8 0 30.5-13.7 30.5-30.5s-13.7-30.5-30.5-30.5zm0 52c-5 0-9.6-1.6-13.5-4.8-5.1-4.1-8-10.2-8-16.7 0-11.9 9.6-21.5 21.5-21.5s21.5 9.6 21.5 21.5-9.6 21.5-21.5 21.5z"
          />
          <path
            fill={color}
            d="M28.3 36.7c2.2-4.1 4.2-7.9 8.1-10.2 3.1-2 6.5-2.4 10-3.6-9.7-5.5-21.3 2.9-18.1 13.8z"
          />
        </svg>
      );
    case TEST_TYPES.VERIFICATION:
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          style={{
            padding: isPadded ? '15%' : 0,
          }}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill={color}
            d="m85.904 61.6-10.2-8.2-.5 3c-.1-.1-.3-.1-.4-.2-3.2-1.4-6.9-2.9-13.7-2.6-6.8.3-10.3 2.2-13.4 3.8-1.6.8-3.1 1.6-5 2.2v-8.3c3.1-.8 5.4-1.9 7.4-3 2.9-1.5 5.3-2.8 10.7-3.1 5.4-.3 7.9.8 10.9 2.1.6.3 1.3.5 1.9.8l-.5 3.3 12.2-4.7-10.2-8.2-.5 3c-.2-.1-.3-.1-.4-.2-3.2-1.4-6.9-2.9-13.7-2.6-6.9.4-10.4 2.3-13.5 3.9-1.4.7-2.7 1.4-4.3 2v-8.3c2.8-.8 4.8-1.8 6.7-2.8 2.9-1.5 5.3-2.8 10.7-3.1 5.4-.2 7.9.8 10.9 2.1.6.3 1.3.5 1.9.8l-.5 3.2 12.2-4.7-10.2-8.2-.5 3c-.2-.1-.3-.1-.4-.2-3.2-1.4-6.9-2.9-13.7-2.6-6.8.3-10.3 2.2-13.4 3.8-1.2.6-2.3 1.2-3.6 1.7v-10c0-1.2-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2v12.4c-.4-.5-1.1-.9-1.8-.8-.3 0-.6 0-1 .1-1.7.1-3.1 0-4.5-.1-1-.1-2 .7-2.2 1.8-.2 1.1.7 2.1 1.8 2.2 1.1.1 2.2.2 3.4.2h1.7c.4 0 .7 0 1.1-.1.6 0 1.1-.4 1.5-.8v11.9c-.3-.2-.7-.2-1.1-.2-.3 0-.6 0-1 .1h-1.5c-1.1 0-2-.1-2.9-.2-1.1-.1-2.1.7-2.2 1.8-.1 1.1.7 2.1 1.8 2.2 1.1.1 2.2.2 3.3.2h1.8c.4 0 .7 0 1.1-.1.3 0 .5-.1.8-.2v11.1h-.4c-.3 0-.6 0-1 .1-1.7.1-3.1 0-4.5-.1-1.1-.1-2.1.7-2.2 1.8-.2 1 .6 2 1.7 2.1 1.1.1 2.2.2 3.4.2h1.7c.4 0 .7 0 1.1-.1h.1v10.9c0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2v-9.2c3.5-.8 5.9-2 8-3.2 2.9-1.5 5.3-2.8 10.7-3.1 5.4-.3 7.9.8 10.9 2.1.6.3 1.3.5 1.9.8l-.5 3.2zm-74.7-31.2h2.8c1.1 0 2-.8 2.1-1.9.1-1.1-.8-2-1.9-2.1h-3.2c-1.1.1-2 1-1.9 2.1 0 1.1.9 1.9 2.1 1.9-.1 0-.1 0 0 0zm11.4 2.2c.6.3 1.3.5 1.9.8.2.1.5.1.7.1.8 0 1.6-.5 1.9-1.3.4-1-.1-2.2-1.2-2.6-.6-.2-1.2-.5-1.8-.7-1.2-.5-2.4-1-3.8-1.4-1.1-.3-2.2.3-2.5 1.3-.3 1.1.3 2.2 1.3 2.5 1.3.4 2.4.8 3.5 1.3zm-10.7 12.7h2.8c1.1 0 2-.8 2.1-1.9.1-1.1-.8-2-1.9-2.1h-3.2c-1.1.1-2 1-1.9 2.1 0 1.1.9 1.9 2.1 1.9-.1 0-.1 0 0 0zm8 .9c1.2.4 2.3.8 3.4 1.3.6.3 1.3.5 1.9.8.2.1.5.1.7.1.8 0 1.6-.5 1.9-1.3.4-1-.1-2.2-1.2-2.6-.6-.2-1.2-.5-1.8-.7-1.2-.5-2.4-1-3.8-1.4-1.1-.3-2.2.3-2.5 1.3-.3 1 .4 2.2 1.4 2.5zm-4.3 10h-3.2c-1.1.1-2 1-1.9 2.1 0 1.1.9 1.9 2 1.9h3c1.1 0 1.9-.8 2-1.9 0-1.1-.8-2-1.9-2.1zm11.8 3.2c-.6-.2-1.2-.5-1.8-.7-1.2-.5-2.4-1-3.8-1.4-1.1-.3-2.2.3-2.5 1.3-.3 1.1.3 2.2 1.3 2.5 1.2.4 2.3.8 3.4 1.3.6.3 1.3.5 1.9.8.2.1.5.1.7.1.8 0 1.6-.5 1.9-1.3.4-1-.1-2.2-1.1-2.6z"
          />
        </svg>
      );
    case HEALTHCARE_TEST_TYPES.NEUTRAL:
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          style={{
            padding: isPadded ? '15%' : 0,
          }}
          xmlns="http://www.w3.org/2000/svg"
          fill={color}
        >
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m70.96571,15.33064H24.03505c-4.7998,0-8.7041,3.9043-8.7041,8.7041v46.93066c0,4.7998,3.9043,8.7041,8.7041,8.7041h46.93066c4.7998,0,8.7041-3.9043,8.7041-8.7041V24.03474c0-4.7998-3.9043-8.7041-8.7041-8.7041Zm2.7041,55.63477c0,1.49121-1.21289,2.7041-2.7041,2.7041H24.03505c-1.49121,0-2.7041-1.21289-2.7041-2.7041V24.03474c0-1.49121,1.21289-2.7041,2.7041-2.7041h46.93066c1.49121,0,2.7041,1.21289,2.7041,2.7041v46.93066Z"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m47.49989,35.67048c-6.52246,0-11.8291,5.30664-11.8291,11.8291,0,6.52344,5.30664,11.83008,11.8291,11.83008s11.8291-5.30664,11.8291-11.83008c0-6.52246-5.30664-11.8291-11.8291-11.8291Zm-8.8291,11.8291c0-4.86816,3.96094-8.8291,8.8291-8.8291,1.57861,0,3.05835.42188,4.34204,1.15063l-10.45752,14.03271c-1.66919-1.60742-2.71362-3.85913-2.71362-6.35425Zm8.8291,8.83008c-1.29443,0-2.52075-.28711-3.62964-.78979l10.29419-13.81348c1.34424,1.54956,2.16455,3.56567,2.16455,5.77319,0,4.86914-3.96094,8.83008-8.8291,8.83008Z"
          />
        </svg>
      );
    case HEALTHCARE_TEST_TYPES.POSITIVE:
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          style={{
            padding: isPadded ? '15%' : 0,
          }}
          xmlns="http://www.w3.org/2000/svg"
          fill={color}
        >
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m55.40337,45.99958h-6.40332v-6.40332c0-.82812-.67188-1.5-1.5-1.5s-1.5.67188-1.5,1.5v6.40332h-6.40332c-.82812,0-1.5.67188-1.5,1.5s.67188,1.5,1.5,1.5h6.40332v6.4043c0,.82812.67188,1.5,1.5,1.5s1.5-.67188,1.5-1.5v-6.4043h6.40332c.82812,0,1.5-.67188,1.5-1.5s-.67188-1.5-1.5-1.5Z"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m62.08501,15.33064h-29.16992c-10.16113,0-26.33887,14.72168-26.33887,32.16895s16.17773,32.16992,26.33887,32.16992h29.16992c10.16113,0,26.33887-14.72266,26.33887-32.16992S72.24614,15.33064,62.08501,15.33064Zm0,58.33887h-29.16992c-5.89844,0-20.33887-11.32617-20.33887-26.16992,0-14.84277,14.44043-26.16895,20.33887-26.16895h29.16992c5.89844,0,20.33887,11.32617,20.33887,26.16895,0,14.84375-14.44043,26.16992-20.33887,26.16992Z"
          />
        </svg>
      );
    case HEALTHCARE_TEST_TYPES.NEGATIVE:
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          style={{
            padding: isPadded ? '15%' : 0,
          }}
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m55.40395,45.99958h-15.80762c-.82812,0-1.5.67188-1.5,1.5s.67188,1.5,1.5,1.5h15.80762c.82812,0,1.5-.67188,1.5-1.5s-.67188-1.5-1.5-1.5Z"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m79.10512,71.30915c-.75391-1.83887-2.14062-3.8916-3.74512-6.26855-3.33789-4.94434-7.49219-11.09766-7.49219-17.54102s4.1543-12.5957,7.49219-17.53906c1.60449-2.37793,2.99121-4.43066,3.74414-6.26855.76465-1.86328.54883-3.97754-.57715-5.65723-1.13477-1.69336-3.0293-2.7041-5.06543-2.7041H21.53871c-2.03613,0-3.92969,1.01074-5.06543,2.70312-1.12598,1.67871-1.34277,3.79395-.57812,5.65723.75391,1.83887,2.13867,3.8916,3.74316,6.26758,3.33887,4.94434,7.49316,11.09766,7.49316,17.54102,0,6.44434-4.1543,12.59766-7.49316,17.54199-1.60449,2.37695-2.98926,4.42871-3.74316,6.26758-.76465,1.86328-.54785,3.97852.57812,5.65723,1.13574,1.69238,3.0293,2.70312,5.06543,2.70312h51.92285c2.03613,0,3.93066-1.01074,5.06543-2.7041,1.12598-1.67969,1.3418-3.79395.57812-5.65625Zm-5.64355,2.36035H21.53871c-.07812,0-.09668-.0752-.09277-.08496.52051-1.26758,1.80469-3.1709,3.16504-5.18555,3.5957-5.3252,8.52051-12.61914,8.52051-20.89941,0-8.2793-4.9248-15.57324-8.52051-20.89844-1.36035-2.01465-2.64453-3.91797-3.16992-5.19434.00098-.00098.01953-.07617.09766-.07617h51.92285c.07715,0,.09668.0752.09082.08496-.51953,1.26855-1.80469,3.17188-3.16504,5.1875-3.5957,5.32422-8.51953,12.61719-8.51953,20.89648s4.92383,15.57324,8.51953,20.89844c1.36035,2.01465,2.64551,3.91797,3.1709,5.19531,0,.00098-.01953.07617-.09668.07617Z"
          />
        </svg>
      );
    case TEST_TYPES.UV:
      return (
        <svg
          viewBox="0 0 95 95"
          width={width}
          style={{
            padding: isPadded ? '15%' : 0,
          }}
        >
          <path
            fill={color}
            d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5M2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1m18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1M11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1m0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1M5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0z"
            transform="translate(0, 5) scale(3.15)"
          />
        </svg>
      );
    default:
      console.error(`Unknown test icon type ${type} provided`);
  }
};

export default TestIcon;
